import React, { useEffect, useState } from "react";
import "../App.scss";
import "./NewPatient.scss";
import jason from "../assets/images/jason.jpg";
import brian from "../assets/images/brian.jpg";
const PrivacyPolicy = () => {
  return (
    <div className="pageContainer">
      <div className="pageHeader">
        <div className="h1 hippiBlue" style={{ marginBottom: "0.5rem" }}>
          Privacy Policy
        </div>
        <div className="b1 midGray">
          We value your privacy very highly. Please read this Privacy Policy
          carefully before using the Vetta Solutions application (the
          “Application”) operated by Vetta Solutions Inc., a(n) C-Corporation
          formed in North Carolina, United States (“us, we, our”) as this
          Privacy Policy contains important information regarding your privacy
          and how we may use the information we collect about you.  Your access
          to or use of the Application is conditional upon your acceptance of
          and compliance with this Privacy Policy. This Privacy Policy applies
          to everyone, including but not limited to visitors, users and others,
          who wish to access or use the Application.  By accessing or using the
          Application, you agree to be bound by this Privacy Policy. If you
          disagree with any part of this Privacy Policy, you do not have our
          permission to access or use the Application.
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            What information we collect and store
          </div>
          <div className="b1 midGray">
            We collect and store any and all information that you enter on this
            Application. We collect and store the following information about
            you: Identifying information - Name Identifying information - IP
            address Identifying information - Email address Identifying
            information - Account name Characteristics of protected
            classifications - Age Characteristics of protected classifications -
            Sex Sensitive personal information - Gait patterns or rhythms
            Sensitive personal information - Sleep, health or exercise data
            Identifying information - Processed Gait Data Sensitive personal
            information - Pain Data Sensitive personal information - Clinical
            notes on gait Identifying information - Subjective notes
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            With whom we share your personal information
          </div>
          <div className="b1 midGray">
            We do not share nor disclose your personal information to any third
            parties.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            Sale of your information
          </div>
          <div className="b1 midGray">
            We do not sell your personal information. Please see the “Your
            Rights” section below for more information about exercising your
            privacy rights regarding sales of your personal information.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            Cookies
          </div>
          <div className="b1 midGray">
            A cookie is a small piece of data sent from a website and stored on
            your device by your browser. Cookies are generally used to allow
            websites to respond to you as an individual, to remember your
            preferences, to test content, and to analyze your interactions with
            websites or with advertisements. This Application does not collect
            cookies.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            Children's privacy
          </div>
          <div className="b1 midGray">
            This Application is intended for use by a general audience and does
            not offer services to children. Should a child whom we know to be
            under 18 send personal information to us, we will use that
            information only to respond to that child to inform them that they
            cannot use this Application.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            The rights of Nevada residents
          </div>
          <div className="b1 midGray">
            Residents of Nevada have the following rights with regard to their
            personal information: the right to opt out of sales of your personal
            information.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            Exercising your rights
          </div>
          <div className="b1 midGray">
            Residents of Nevada may exercise the rights specified above by
            submitting a consumer request to: Jason Franz -
            contact@vettasolutions.com 6409 Fayetteville Road, Suite 120-173
            Durham, NC 27713United States We will need to verify your identity
            prior to effectuating your request and may ask you to provide
            personal information to do so.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            Do Not Track
          </div>
          <div className="b1 midGray">
            Do Not Track (“DNT”) is a preference you can set on your browser to
            inform websites that you do not want to be tracked. We do not
            support DNT. You can either enable or disable Do Not Track by
            visiting the Preferences or Settings page of your browser.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            Changes to Privacy Policy
          </div>
          <div className="b1 midGray">
            We reserve the right to amend this Privacy Policy at any time. We
            will notify you of any changes to this Privacy Policy by posting the
            updated Privacy Policy to this application.
          </div>
        </div>
        <div>
          <div className="h1 hippiBlue" style={{ margin: "2rem 0 0.5rem 0" }}>
            Questions
          </div>
          <div className="b1 midGray">
            If you have any questions about this Privacy Policy, please contact
            us at contact@vettasolutions.com.
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
